<template>
  <div id="app">
    <header class="head">
      <a class="back tl" @click="exit()">
        <i class="el-icon-arrow-left"></i>
      </a>
      <a href="javascript:;" class="tc">
        <small class="font_18 co_f">点评</small>
      </a>

    </header>
    <main>
      <div class="seller-content">
        <div class="overview">
          <span class="title">{{enterpriseName}}</span>
        </div>

      </div>
      <div class="ratings-content">
        <div class="overview">

          <div class="overview-right">
            <div class="score-wrapper">
              <span class="title">环境</span>

              <el-rate v-model="value5" show-text>
              </el-rate>
            </div>
            <div class="score-wrapper">
              <span class="title">菜品</span>
              <el-rate v-model="value6" show-text>
              </el-rate>
            </div>
            <div class="score-wrapper">
              <span class="title">服务</span>
              <el-rate v-model="value7" show-text>
              </el-rate>
            </div>
          </div>
        </div>
      </div>
      <div style="padding:5px">
        <el-input type="textarea" :rows="3" placeholder="请输入您的点评内容" v-model="textarea">
        </el-input>
      </div>
      <div style="padding:5px">
        <el-upload action="" :file-list="filelist" list-type="picture-card" :before-upload="beforeAvatarUpload" :http-request="handleUpload" :on-remove="handRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <div style="padding:5px">
        <el-button type="primary" style="width:100%" @click="btnAdd()">提交</el-button>
      </div>

    </main>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  GetGuid,
  EnterrpriseReviewAdd,
  unwantedTokenUploadFile,
  unwantedTokenDeleteFileForSingle,
} from "@/api/api";
import goBackS from "@/page/index/goBackS";
export default {
  components: {},
  data() {
    return {
      userInfo: "",
      unid: "",
      dialogVisible: false,
      enterpriseName: "",
      enterpriseUnid: "",
      textarea: "",
      value5: 5,
      value6: 5,
      value7: 5,
      filelist: [],
    };
  },

  mounted() { },
  methods: {
    exit: function () {
      // this.$router.go(-1);
      this.$router.push({
        name: "Index",
        query: {
          unid: this.$route.query.unid
        },
        params: {
          isG: true
        }
      })
    },
    btnAdd: function () {
      let value8 = (this.value5 + this.value6 + this.value7) / 3;
      let varData = {
        unid: this.unid,
        enterpriseName: this.$route.query.name,
        enterpriseUnid: this.$route.query.unid,
        note: this.textarea,
        environmentScore: this.value5,
        varietyScore: this.value7,
        serviceScore: this.value7,
        comprehensiveScore: value8,
        userName: "公众点评",
        userUnid: "公众点评",
        reply: "",
      };
      let options = {
        data: JSON.stringify(varData),
      };
      //调取接口
      EnterrpriseReviewAdd(options).then((res) => {
        if (res.success === true) {
          // this.$router.go(-1);
          this.$router.push({
            name: "Index",
            query: {
              unid: this.$route.query.unid
            },
            params: {
              isG: true
            }
          })
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    handleUpload(file) {
      let fd = new FormData();
      fd.append("files ", file.file);
      fd.append("mainDataUnid", this.unid);
      fd.append("needCompress", 1);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      unwantedTokenUploadFile(fd, config).then((res) => {
        if (res.success) {
          this.filelist = res.data.map((i) => {
            return {
              name: i.name,
              unid: i.unid,
              url: window.IPConfig.baseIP + i.files.fullpath,
            };
          });
        }
      });
    },

    handRemove(file, fileList) {
      this.GetDeleteFile(file.unid);
    },
    //获取unid
    getData() {
      let options = {
        params: {},
      };
      //调取接口
      GetGuid(options).then((res) => {
        if (res.success === true) {
          this.unid = res.data;
        }
      });
    },
    //删除附件
    GetDeleteFile(unid) {
      let options = {
        ids: unid,
      };
      //调取接口
      unwantedTokenDeleteFileForSingle(options).then((res) => {
        if (res.success === true) {
        }
      });
    },
  },
  //页面加载时候
  created() {
    this.enterpriseName = this.$route.query.name;
    this.getData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  >
.el-upload-list__item-status-label {
  line-height: 1.8 !important;
}
.el-upload-list--picture-card .el-upload-list__item,
.el-upload--picture-card {
  width: 90px !important;
  line-height: 90px !important;
  height: 90px !important;
}
</style>
<style lang="scss" scoped>
.container {
  width: 100%;
  background: #000;
}
.overview {
  display: flex;
  padding: 8px 0;
  align-items: center;

  .overview-right {
    flex: 1;

    .score-wrapper {
      padding: 5px 24px;
      line-height: 18px;
      margin-bottom: 8px;
      height: 18px;

      @media only screen and (max-width: 320px) {
        padding: 0 5px;
      }

      .title {
        font-size: 1rem;
        line-height: 18px;
        font-weight: 500;
        text-align: center;
        margin: 0px 12px 8px 0;
        float: left;
      }

      .score {
        font-size: 0.32rem;
        color: rgb(255, 153, 0);
        line-height: 18px;
        font-weight: 500;
        vertical-align: center;
        margin: 0px 12px 8px 0;
      }
    }
  }
}

.seller-content {
  display: flex;
  padding: 6px 3px;

  border-top: 3px solid #f8f8f8;
  border-bottom: 1.5px solid #f8f8f8;
  align-items: center;

  .overview {
    width: 80%;
    font-size: 1rem;
  }

  .favorite {
    background: url(../../img/add.png);
    width: 100%;
    height: 100%;
    float: right;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    max-width: 15%;
    max-width: 15%;
  }
}
</style>



// WEBPACK FOOTER //
// EntEvaluate.vue?a3184d86